import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import Badge from '@material-ui/core/Badge';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuList from '@material-ui/core/MenuList';
import Fade from '@material-ui/core/Fade';

// images
import IDB from '../../assets/img/IDB-Logo.png';
import Perfil3 from '../../assets/img/perfil-6.png';
import { NotificationsService } from '../../services/notifications.service';
import { NotificationAlert } from '../../models/notifications.model';
import { Programa } from '../../models/programas.model';
import { ProgramasService } from '../../services/programas.service';
import { General } from '../../services/general';
import { ClickAwayListener } from '@material-ui/core';
import { useMsal } from '@azure/msal-react';
const moment = require('moment');

export default function Header({ setMe, roleLoaded }: any) {
    const userRol = JSON.parse(localStorage.getItem('Roles') as string);
    const user = JSON.parse(localStorage.getItem('currentUsr')!);
    const { instance } = useMsal();
    const navigate = useNavigate();
    const notificationsService = NotificationsService({ locale: 'en' });
    const programasService = ProgramasService({ locale: 'en' });
    const [notifications, setNotifications] = React.useState<NotificationAlert[]>([]);
    const [programas, setProgramas] = React.useState<Programa[]>([]);
    const [username, setUsername] = React.useState<string>('user');

    const [anchEl, setAnchEl] = React.useState<null | HTMLElement>(null);
    const opn = Boolean(anchEl);

    const handClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchEl(event.currentTarget);
    };
    const onClose = () => {
        setAnchEl(null);
    };

    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef<HTMLButtonElement>(null);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    function handleListKeyDown(event: React.KeyboardEvent) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        }
    }

    const getNotifications = () => {
        notificationsService
            .getNotifications({
                statusId: 0,
            })
            .then((response: any) => {
                setNotifications(response.data);
            });
    };

    const changeComponent = (redirected: string): void => {
        navigate({ pathname: redirected });
    };

    function logOut() {
        localStorage.clear();
        instance.logoutRedirect();
        setMe(false);
    }

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = React.useRef(open);

    const requiredOnwer = (): boolean => {
        let result = false;
        if (user && localStorage.getItem('Roles')) {
            const owner = userRol ? userRol.filter((s: any) => s.Name === 'Owner') : null;
            if (owner && owner.length > 0) {
                result = true;
            }
        }
        return result;
    };

    const requiredSpecialist = (): boolean => {
        let result = false;
        if (user && localStorage.getItem('Roles')) {
            const specialist = userRol ? userRol.filter((s: any) => s.Name === 'Specialist') : null;
            if (specialist && specialist.length > 0) {
                result = true;
            }
        }
        return result;
    };

    React.useEffect(() => {
        requiredOnwer();
        requiredSpecialist();
        if (user) {
            user.name ? setUsername(user.name) : setUsername(user.username);
        }

        if (prevOpen.current === true && open === false) {
            anchorRef.current!.focus();
        }
        programasService.getProgramas().then((response: any) => {
            const programs = response.data;
            setProgramas(programs);
            getNotifications();
        });
        prevOpen.current = open;

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    return (
        <nav id='header' className='navbar navbar-expand-md navbar-light'>
            <div className='container'>
                <span className='navbar-brand' onClick={() => changeComponent('/home')}>
                    <img src={IDB} width='auto' height='80' className='' alt='' />
                    <span>Dashboard de Obras</span>
                </span>
                <button
                    className='navbar-toggler'
                    type='button'
                    data-toggle='collapse'
                    data-target='#navbarNav'
                    aria-controls='navbarNav'
                    aria-expanded='false'
                    aria-label='Toggle navigation'>
                    <span className='navbar-toggler-icon'></span>
                </button>
                <div className='collapse navbar-collapse' id='navbarNav'>
                    <ul className='navbar-nav'>
                        <li className='nav-item'>
                            <span className='nav-link' onClick={() => changeComponent('/home')}>
                                Inicio
                            </span>
                        </li>
                        <li className='nav-item'>
                            <span
                                className='nav-link'
                                onClick={() => changeComponent('/update-data')}>
                                Actualizar Datos
                            </span>
                        </li>
                        {/* <li className="nav-item">
                            <a className="nav-link" href="#">Download database</a>
                        </li> */}
                        <li className='nav-item'>
                            <Button
                                className='nav-link'
                                ref={anchorRef}
                                aria-controls={open ? 'menu-list-grow' : undefined}
                                aria-haspopup='true'
                                onClick={handleToggle}>
                                <span>{username}</span> <span className='icon-user'></span>
                            </Button>
                            <Popper
                                open={open}
                                anchorEl={anchorRef.current}
                                role={undefined}
                                transition
                                disablePortal
                                style={{ zIndex: 1 }}>
                                {({ TransitionProps, placement }) => (
                                    <Grow
                                        {...TransitionProps}
                                        style={{
                                            transformOrigin:
                                                placement === 'bottom'
                                                    ? 'center top'
                                                    : 'center bottom',
                                        }}>
                                        <Paper>
                                            <ClickAwayListener onClickAway={() => setOpen(false)}>
                                                <MenuList
                                                    autoFocusItem={open}
                                                    id='menu-list-grow'
                                                    onKeyDown={handleListKeyDown}>
                                                    <span
                                                        className='menu-item_profile'
                                                        onClick={() => changeComponent('/profile')}>
                                                        Mi perfil
                                                    </span>
                                                    <hr />
                                                    {requiredOnwer() && (
                                                        <div>
                                                            <span
                                                                className='menu-item_profile'
                                                                onClick={() =>
                                                                    changeComponent('/admin-users')
                                                                }>
                                                                Administrar usuarios
                                                            </span>
                                                            <hr />
                                                        </div>
                                                    )}
                                                    <span
                                                        className='menu-item_profile'
                                                        onClick={logOut}>
                                                        Salir
                                                    </span>
                                                </MenuList>
                                            </ClickAwayListener>
                                        </Paper>
                                    </Grow>
                                )}
                            </Popper>
                        </li>
                    </ul>
                    {/* <li className="nav-item"> */}
                    {(requiredOnwer() || requiredSpecialist()) && (
                        <div>
                            <Button
                                aria-controls='fade-menu'
                                aria-haspopup='true'
                                onClick={handClick}>
                                <Badge className='notification' badgeContent={notifications.length}>
                                    <span className='icon_bell_Notificaciones'>
                                        <span className='path1'></span>
                                        <span className='path2'></span>
                                        <span className='path3'></span>
                                        <span className='path4'></span>
                                    </span>
                                </Badge>
                            </Button>
                            <Menu
                                id='fade-menu'
                                anchorEl={anchEl}
                                keepMounted
                                open={opn}
                                onClose={onClose}
                                TransitionComponent={Fade}>
                                {notifications.length === 0 && (
                                    <span onClick={() => changeComponent('/notifications')}>
                                        Notificaciones
                                    </span>
                                )}
                                {notifications.length > 0 &&
                                    notifications.map(
                                        (notification: NotificationAlert, index: number) => {
                                            return (
                                                <div key={index}>
                                                    {notification.notificationType ===
                                                        General.NotificationType.UpdateProjects && (
                                                            <span
                                                                className='d-flex notification'
                                                                onClick={() =>
                                                                    changeComponent('/notifications')
                                                                }>
                                                                <div className='col-1'>
                                                                    <img
                                                                        className='perfil w-100'
                                                                        src={Perfil3}
                                                                        alt=''
                                                                    />
                                                                </div>
                                                                <div className='col-11 pad-10'>
                                                                    <p>
                                                                        <strong>
                                                                            {notification.createdBy}
                                                                        </strong>
                                                                        Se acaba de hacer un cambio en{' '}
                                                                        {programas.length > 0 &&
                                                                            programas.filter(
                                                                                (s) =>
                                                                                    s.oid ===
                                                                                    notification.programId
                                                                            )[0].descripcion}{' '}
                                                                        y necesita aprobación
                                                                    </p>
                                                                    <span>
                                                                        {moment(
                                                                            notification.notificationDate
                                                                        ).format('MM/DD/YYYY hh:MM A')}
                                                                    </span>
                                                                </div>
                                                            </span>
                                                        )}
                                                    {notification.notificationType ===
                                                        General.NotificationType.CreateObra && (
                                                            <span
                                                                className='d-flex notification'
                                                                onClick={() =>
                                                                    changeComponent('/notifications')
                                                                }>
                                                                <div className='col-1'>
                                                                    <img
                                                                        className='perfil w-100'
                                                                        src={Perfil3}
                                                                        alt=''
                                                                    />
                                                                </div>
                                                                <div className='col-11 pad-10'>
                                                                    <p>
                                                                        <strong>
                                                                            {notification.createdBy}
                                                                        </strong>
                                                                        Se acaba de crear una obra en{' '}
                                                                        {programas.length > 0 &&
                                                                            programas.filter(
                                                                                (s) =>
                                                                                    s.oid ===
                                                                                    notification.programId
                                                                            )[0].descripcion}{' '}
                                                                        y necesita aprobación
                                                                    </p>
                                                                    <span>
                                                                        {moment(
                                                                            notification.notificationDate
                                                                        ).format('MM/DD/YYYY hh:MM A')}
                                                                    </span>
                                                                </div>
                                                            </span>
                                                        )}
                                                    {notification.notificationType ===
                                                        General.NotificationType
                                                            .AssignProgramsAndCountriesUser &&
                                                        requiredOnwer() && (
                                                            <span
                                                                className='d-flex notification'
                                                                onClick={() =>
                                                                    changeComponent('/admin-users')
                                                                }>
                                                                <div className='col-1'>
                                                                    <img
                                                                        className='perfil w-100'
                                                                        src={Perfil3}
                                                                        alt=''
                                                                    />
                                                                </div>
                                                                <div className='col-11 pad-10'>
                                                                    <p>
                                                                        <strong>
                                                                            Asignar programams y
                                                                            paises a usuario{' '}
                                                                            {
                                                                                notification.userNameAssignPrograms
                                                                            }
                                                                        </strong>{' '}
                                                                    </p>
                                                                    <span>
                                                                        {moment(
                                                                            notification.notificationDate
                                                                        ).format(
                                                                            'MM/DD/YYYY hh:MM A'
                                                                        )}
                                                                    </span>
                                                                </div>
                                                            </span>
                                                        )}
                                                    <hr />
                                                </div>
                                            );
                                        }
                                    )}
                                <span
                                    className='ver-notificaciones'
                                    onClick={() => changeComponent('/notifications')}>
                                    <b>Ver Notificaciones</b>
                                </span>
                            </Menu>
                        </div>
                    )}
                </div>
            </div>
        </nav>
    );
}
